var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgError = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 416 416",
    style: {
      enableBackground: "new 0 0 416 416"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29ABE2"
    },
    d: "M24,4h336c13.255,0,24,10.745,24,24v272c0,13.255-10.745,24-24,24H24c-13.255,0-24-10.745-24-24V28 C0,14.745,10.745,4,24,4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M0,260h384l0,0v40c0,13.255-10.745,24-24,24H24c-13.255,0-24-10.745-24-24V260L0,260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3B3"
    },
    d: "M184,284h16v16h-16V284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M264,412H32c-8.837,0-16-7.163-16-16s7.163-16,16-16h208L264,412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M80,380l40-56h144v56H80z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80CAEC"
    },
    d: "M32,212h176v16H32V212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80CAEC"
    },
    d: "M48,180h16v16H48V180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80CAEC"
    },
    d: "M80,180h128v16H80V180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80CAEC"
    },
    d: "M176,68h176v16H176V68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80CAEC"
    },
    d: "M176,100h176v16H176V100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80CAEC"
    },
    d: "M192,36h16v16h-16V36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80CAEC"
    },
    d: "M224,36h128v16H224V36z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DA4836"
    },
    cx: 96,
    cy: 100,
    r: 56
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M125.656,81.656l-11.312-11.312L96,88.688L77.656,70.344L66.344,81.656L84.688,100l-18.344,18.344 l11.312,11.312L96,111.312l18.344,18.344l11.312-11.312L107.312,100L125.656,81.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0071BC"
    },
    d: "M376,132H248c-13.255,0-24,10.745-24,24v104h176V156C400,142.745,389.255,132,376,132z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3B3"
    },
    d: "M224,260h16v64h-16V260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3B3"
    },
    d: "M240,388v-8h-16v8c0,13.255,10.745,24,24,24l0,0h16C250.745,412,240,401.255,240,388L240,388z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M224,324h16v56h-16V324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29ABE2"
    },
    d: "M264,148h128c13.255,0,24,10.745,24,24v216c0,13.255-10.745,24-24,24H264c-13.255,0-24-10.745-24-24 V172C240,158.745,250.745,148,264,148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M240,348h176l0,0v40c0,13.255-10.745,24-24,24l0,0H264c-13.255,0-24-10.745-24-24l0,0V348L240,348z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DA4836"
    },
    cx: 328,
    cy: 252,
    r: 56
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M357.656,233.656l-11.312-11.312L328,240.688l-18.344-18.344l-11.312,11.312L316.688,252 l-18.344,18.344l11.312,11.312L328,263.312l18.344,18.344l11.312-11.312L339.312,252L357.656,233.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3B3"
    },
    d: "M320,372h16v16h-16V372z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgError, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/error.65fc986c.svg";
export { ForwardRef as ReactComponent };